var _ModifyProfileCommand_socket;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
export class ModifyProfileCommand {
    constructor(socket) {
        _ModifyProfileCommand_socket.set(this, void 0);
        __classPrivateFieldSet(this, _ModifyProfileCommand_socket, socket, "f");
    }
    execute(privateKey, userInfo) {
        __classPrivateFieldGet(this, _ModifyProfileCommand_socket, "f").send({
            commandType: 'modify-profile',
            resource: {
                privateKey,
                userInfo,
            },
        });
    }
}
_ModifyProfileCommand_socket = new WeakMap();
